import { useState, useLayoutEffect } from "react";

/** Breakpoint matching Tailwind lg (1024px) - use consistently across home template */
export const DESKTOP_BREAKPOINT = 1024;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;

/**
 * Hook to detect viewport breakpoint. Returns true when desktop (>= 1024px), false when mobile.
 * Returns null during SSR and initial hydration to avoid loading wrong images.
 * Uses useLayoutEffect to resolve before paint and minimize placeholder flash.
 */
export const useMediaQuery = (query = DESKTOP_MEDIA_QUERY) => {
  const [matches, setMatches] = useState(null);

  useLayoutEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = (e) => setMatches(e.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
};

/** Convenience hook: true when desktop (>= 1024px), false when mobile */
export const useIsDesktop = () => useMediaQuery(DESKTOP_MEDIA_QUERY);
